var lib_core = require("lib-core");

var PathViewerStateMachine = function (root, model){
    var self = this;
    this.root = root;
    this.model = model;
    lib_core.StateMachine.call(self);

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.PATH_SMOOTH_BEZIER_CONVERT;
        },
        function(cEvent){
            self.root.rec();
            cEvent.element().convertToSmoothBezierPoint();
            self.root.stopRec();
        }
    );
};

lib_core.inherit(PathViewerStateMachine, lib_core.StateMachine);

module.exports = PathViewerStateMachine;
